module.exports = __webpack_public_path__ + "img/message-close.3ac36ca3.png";